import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    ArrowLeftOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons';
import { useRestaurant } from '../context/RestaurantContext';
import Disclaimer from './Disclaimer';
import landingIcon from '../assets/language-icon.svg';

import { Button } from 'antd';
import { IMAGE_ROOT_URL } from '../constants';
import { useLanguage } from '../context/LanguageContext';
import LanguagePopup from './LanguagePopup';
const Header = (props) => {
    const { restaurantDetails } = useRestaurant();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { langList } = useLanguage();

    const navigate = useNavigate();
    const {
        showBack,
        popupData,
        backBtnHandler,
        disclaimerText = '',
        showLang,
    } = props;

    console.log(popupData);
    

    const [isDisclaimer, setisDisclaimer] = useState(false);

    const openDisclaimer = () => setisDisclaimer(true);
    const closeDisclaimer = () => setisDisclaimer(false);
    return (
        <div className=' header-new flex items-center w-full sticky top-0 z-50'>
            <div className='flex items-center justify-between pl-2 pr-2 w-full h-full py-1 gap-4'>
                {showBack && (
                    <Button
                        shape='circle'
                        icon={<ArrowLeftOutlined />}
                        className='shadow-sm'
                        onClick={
                            backBtnHandler ? backBtnHandler : () => navigate(-1)
                        }
                    ></Button>

                    // <div
                    //     className='arrow-back-icon'
                    //     onClick={
                    //         backBtnHandler
                    //             ? backBtnHandler
                    //             : () => navigate(-1)
                    //     }
                    // >
                    //   <LeftOutlined/>
                    // </div>
                )}
                <img
                    onClick={() => navigate('/')}
                    src={`${IMAGE_ROOT_URL}restaurant-properties/${restaurantDetails?.logo}`}
                    alt={`${restaurantDetails?.name || ''} logo`}
                    className={'w-full h-full object-contain max-w-28'}
                />
                <div className='flex flex-row justify-center items-center gap-2'>
                    {popupData || showLang ? (
                        <>
                            {showLang && langList.length > 0 && (
                                <div
                                    className='language-selector flex justify-center items-center'
                                    onClick={() => setIsModalOpen(true)}
                                >
                                    <img
                                        src={landingIcon}
                                        alt='Language'
                                        className='language-icon'
                                    />
                                </div>
                            )}
                            {popupData && (
                                <div className='' onClick={openDisclaimer}>
                                    <InfoCircleOutlined
                                        style={{
                                            fontSize: showLang?'19px': '22px',
                                            color: 'rgb(203 201 199)',
                                        }}
                                    />
                                </div>
                            )}
                        </>
                    ) : (
                        <div className='w-6 h-6'></div>
                    )}
                </div>
            </div>
            <Disclaimer
                onClose={closeDisclaimer}
                open={isDisclaimer}
                disclaimerText={disclaimerText}
            />
            {isModalOpen && (
                <LanguagePopup
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                />
            )}
        </div>
    );
};

export default Header;
